@if (options()) {
  @if (options().label) {
    <label
      [id]="options().label?.id"
      [for]="!invalidMessage && options().id"
      [class]="'form-label ' + (options().label?.class || '')"
    >
      {{ translations.labels[options().label?.text || 'label'] || options().label?.text }}
      @if (options().required) {
        <span class="text-danger">*</span>
      }
    </label>
  }
  <div ngbDropdown class="input-group row mx-0" #ddEl="ngbDropdown">
    <button
      #mainBtn
      type="button"
      [class]="'ddBtn d-flex justify-content-between align-items-center btn btn-outline-primary text-start ' + extraClasses"
      [id]="options().id"
      (click)="onClick($event)"
      [disabled]="options().formControl ? options().formControl?.disabled : options().disabled"
      ngbDropdownToggle
    >
      @if(selectedItem().hasOwnProperty('item')) {
        <div class="flex-grow-1 text-value">
          {{ selectedItem().item?.[options().descriptionKey || 'description'] }}
        </div>
      } @else {
        <div class="flex-grow-1 text-placeholder">
          {{ translations.placeholders[options().placeholder || 'default'] }}
        </div>
      }
      @if (options().isLoading) {
        <div class="loading spinner-border text-secondary me-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      }
    </button>
    @if(options().formControl) {
      <input
        #hiddenEl
        type="hidden"
        [attr.name]="options().name + '_hidden'"
        class="form-control hidden"
        [required]="options().required || false"
        [value]="options().value"
        [formControl]="options().formControl!"
      >
    }
    <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
      @if (options().searchComponent) {
        <ng-container
          [ngComponentOutlet]="options().searchComponent || null"
          [ngComponentOutletInputs]="{
            data: {
              allData: _filteredData,
              api: options().api,
              onSearch: onSearch
            },
          }"
          #search="ngComponentOutlet"
        />
      }
      @if(selectedItem().hasOwnProperty('item')) {
        <div ngbDropdownItem class="selectedItem d-inline-flex justify-content-between">
          <span>{{ selectedItem().item?.[options().descriptionKey || 'description'] }}</span>
          <i class="bi bi-x" (click)="clearSelection()"></i>
        </div>
      }
      @if(options().searchComponent || Object.keys(selectedItem()).length > 0) {
        <div class="dropdown-divider"></div>
      }
      <div class="items-area">
        @if(filteredData.length > 0) {
          @for (row of filteredData; track $index; let ri = $index) {
            <button type="button" ngbDropdownItem (click)="onSelect(row, ri);">
              @if(options().itemTemplate) {
                <ng-container *ngTemplateOutlet="options().itemTemplate; context: {$implicit: row}" />
              } @else {
                {{ filteredData[ri][options().descriptionKey || 'description'] }}
              }
            </button>
          }
        } @else if (data.length > 0) {
          @for (row of data; track $index; let ri = $index) {
            <button type="button" ngbDropdownItem (click)="onSelect(row, ri);">
              @if(options().itemTemplate) {
                <ng-container *ngTemplateOutlet="options().itemTemplate; context: {$implicit: row}" />
              } @else {
                {{ data[ri][options().descriptionKey || 'description'] }}
              }
            </button>
          }
        } @else {
          <div class="d-flex flex-column px-3">{{translations.noData}}</div>
        }
      </div>
    </div>
  </div>
}
